import { MakePaymentFormValues } from '../../models';

export class FetchPatientBalance {
  static readonly type = '[Payments] Fetch Patient Balance';
}

export class MakePayment {
  static readonly type = '[Payments] Make Payment';
  constructor(public formValues: MakePaymentFormValues) {}
}
